import { Navbar, Nav, Container } from "react-bootstrap/";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "./NavbarComponent.css";
import Resume from "../Assets/Divyansh Goyal's Resume.pdf";

function NavbarComponent() {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: "/", label: "About Me" },
    { to: "/technicalExperience", label: "Work Experience" },
    { to: "/projects", label: "Projects & Designs" },
    { to: "/photographyPortfolio", label: "Photography" },
  ];

  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  return (
    <Navbar
      expanded={expanded}
      onToggle={(isExpanded) => setExpanded(isExpanded)}
      expand="lg"
      fixed="top"
      className="navbarMainTag"
    >
      <Container fluid className="px-3 px-md-4">
        <Navbar.Brand className="dgLogoContainer" as={Link} to="/">
          DG
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="responsive-navbar-nav" className="navbarToggler customToggler">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="white"
            className="bi bi-list"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg>
        </Navbar.Toggle>

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="m-auto NavContent">
            {navLinks.map((link) => (
              <Nav.Item key={link.to} className="mx-2 mx-xl-3 my-1 my-lg-0">
                <NavLink
                  to={link.to}
                  end
                  className={({ isActive }) =>
                    `underlineNav ${isActive ? "active" : ""}`
                  }
                >
                  {link.label}
                </NavLink>
              </Nav.Item>
            ))}
          </Nav>

          <Nav className="d-flex align-items-center gap-2 mt-3 mt-lg-0">
            <a
              href={Resume}
              target="_blank"
              rel="noopener noreferrer"
              className="resumeNavBtn"
            >
              📄 Resume
            </a>
            <a href="#contactMe" className="contactNavBtn">
              Contact Me
            </a>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarComponent;
